/* eslint-disable comma-dangle */
/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:13:17
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2021-04-25 22:19:22
 */

import mould from './mould'

const guard = {

  /**
   * 需要
   */
  need: [],

  /**
   * 不需要
   */
  unwante: [
    mould.notFind.name,
    mould.index.name,
    mould.article.name,
    mould.activity.name,
    mould.activityDetails.name,
    mould.pay.name
  ],
  /**
   * 公共
   */
  public: []

}

export default guard



// WEBPACK FOOTER //
// ./src/router/guard.js